import { Box, Typography } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface GenericResearchQueriesEmptyStateProps {
  queries?: unknown[];
}

const GenericResearchQueriesEmptyState = ({
  queries,
}: GenericResearchQueriesEmptyStateProps) => {
  const { t } = useAppTranslation();

  if (queries?.length) return null;

  return (
    <Box
      role="status"
      sx={{ py: 3, mt: "6px", textAlign: "center", color: "text.secondary" }}
    >
      <Typography variant="body2">
        {t("genericResearchQuery.emptyStates.noQueries")}
      </Typography>
    </Box>
  );
};

export default GenericResearchQueriesEmptyState;
